import { ofType } from "redux-observable";
import * as Rx from "rxjs";
import * as RxOp from "rxjs/operators";
import * as S from "sanctuary";

import {
  COMPONENT_NAMESPACE,
  REQUEST_GET_PAYMENT,
  getPaymentStarted,
  getPaymentSucceeded,
  getPaymentFailed,
} from "../Payment.state";
import { getPayment } from "@/APIClient";
import { requestEpic } from "@/APIClient/observable.util";
import { namespaceToMountedActionType } from "@/components/mountConnected";
import { history } from "@/util/history";
import { getAuthToken } from "@/util/session";

const getPaymentId = () => {
  const matches = history.location.pathname.match(/\d+$/);
  if (!matches) {
    throw { message: "Invalid id query parameter" };
  }
  return matches[0];
};

const getPaymentEpic = (action$) =>
  action$.pipe(
    ofType(
      REQUEST_GET_PAYMENT,
      namespaceToMountedActionType({ COMPONENT_NAMESPACE })
    ),
    RxOp.mergeMap(() =>
      Rx.concat([
        Rx.of(getPaymentStarted()),
        requestEpic({
          requestMethod: getPayment,
          requestArgs: {
            id: getPaymentId(),
            token: S.fromMaybe("")(getAuthToken()),
          },
          onSuccess: (res) => Rx.of(getPaymentSucceeded({ payment: res.value })),
          onFailure: (err) => Rx.of(getPaymentFailed({ error: err })),
        }),
      ])
    ),
    RxOp.concatAll(),
    RxOp.catchError((err) => Rx.of(getPaymentFailed({ error: err.message })))
  );

export default getPaymentEpic;
